import './style.scss';

import React from 'react';
import {
  Progress,
  Text,
  Title,
  TitleProps
} from '@gjensidige/builders-components';

import { HeaderStepsProps } from './types';

export type ComponentProps = HeaderStepsProps;

export const HeaderProgress: React.FC<ComponentProps> = ({
  mainHeaderTxt,
  mainHeaderDescription,
  secondHeaderTxt,
  secondHeaderDescription,
  steps,
  stepValue
}: ComponentProps) => {
  return (
    <div className="step-header header-progress-component">
      <Title
        className="header-main-title"
        as={'h1' as TitleProps['as']}
        size="3"
      >
        {mainHeaderTxt}
      </Title>
      <Text className="main-header-description" size="body">
        {mainHeaderDescription}
      </Text>
      {Array.isArray(secondHeaderTxt) ? (
        secondHeaderTxt.map((text: string, index: number) => {
          return (
            <Text
              size="large"
              weight="700"
              className="second-header-text"
              key={index}
            >
              {text}
            </Text>
          );
        })
      ) : (
        <Text weight="700" size="large" className="second-header-text">
          {secondHeaderTxt}
        </Text>
      )}
      <Text className="second-header-description" size="body">
        {secondHeaderDescription}
      </Text>
      <div className="timeline-wrapper">
        <Progress
          aria-label="försäkringsköp framsteg"
          data-testid="horizontal-default"
          variant="step-horizontal"
          value={stepValue}
        >
          {steps.map((step, index) => {
            return (
              <Progress.Step key={index}>
                <Text weight="700" className="header-progress-step-label">
                  {step.description}
                </Text>
                {step.additionalDescription && (
                  <Text size="body">{step.additionalDescription}</Text>
                )}
              </Progress.Step>
            );
          })}
        </Progress>
      </div>
    </div>
  );
};
